export const OrderActionTypes = {
  SET_ORDERS: "@@order/SET_ORDERS",
  SET_ORDERS_ERROR: "@@order/SET_ORDERS_ERROR",
  SET_SELECTED_ORDER: "@@order/SET_SELECTED_ORDER",
  SET_EXPANDED_ORDER: "@@order/SET_EXPANDED_ORDER",
  UPDATE_ORDER: "@@order/UPDATE_ORDER",
  SET_ORDER: "@@order/SET_ORDER",
  SET_ORDER_ERROR: "@@order/SET_ORDER_ERROR",
  SET_ORDER_SEARCH_RESULTS: "@@order/SET_ORDER_SEARCH_RESULTS",
  SET_ORDER_SEARCH_ERROR: "@@order/SET_ORDER_SEARCH_ERROR",
  ACTIVATE_TICKET: "@@order/ACTIVATE_TICKET",
  ACTIVATE_TICKET_SUCCESS: "@@order/ACTIVATE_TICKET_SUCCESS",
  ACTIVATE_TICKET_ERROR: "@@order/ACTIVATE_TICKET_ERROR",
}; 